import React from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckIcon from '@material-ui/icons/Check';

interface ReadAllStatusButtonProps {
  onClick: () => void;
  isRead: boolean;
  style?: React.CSSProperties;
}

const ReadAllStatusButton: React.FC<ReadAllStatusButtonProps> = ({ onClick, isRead, style }) => {
  return (
    <Button
      variant="contained"
      color={'primary'}
      style={
        style
          ? style
          : {
              marginTop: '10px',
              pointerEvents: 'auto',
            }
      }
      size="small"
      onClick={onClick}
      disabled={isRead}
    >
      {isRead ? (
        <>
          <CheckIcon fontSize="small" color="inherit" />
          <Typography variant="body2" display="inline" style={{ marginLeft: '5px' }}>
            既読
          </Typography>
        </>
      ) : (
        <>
          <VisibilityIcon fontSize="small" color="inherit" />
          <Typography variant="body2" display="inline" style={{ marginLeft: '5px' }}>
            既読
          </Typography>
        </>
      )}
    </Button>
  );
};

export default ReadAllStatusButton;
